import React from 'react';
import { blue, grey } from '@mui/material/colors';
import { Edit, Delete } from '@mui/icons-material';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { PresetFilter, PresetFilterActions } from './types';

interface Props<Value> {
  actionsLoading: boolean;
  filter: PresetFilter<Value>;
  actions: PresetFilterActions;
}

export const Preset = <Value,>({ filter, actions, actionsLoading }: Props<Value>) => {
  return (
    <Box
      sx={{
        gap: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '0.4rem',
        padding: '0.3rem 0.4rem',
        cursor: filter.isSelected ? 'default' : 'pointer',
        border: `1px solid ${filter.isSelected ? blue[500] : grey[500]}`,

        '&:hover': ({ shadows }) => shadows[1],
      }}
      onClick={() => actions.onSelect(filter.id)}
    >
      <Typography
        variant="body2"
        fontWeight={filter.isSelected ? 400 : 500}
        color={filter.isSelected ? 'primary' : 'textPrimary'}
      >
        {filter.name}
      </Typography>

      <Stack gap="0.5rem" direction="row">
        <RenderWithCondition condition={typeof actions.onEdit === 'function'}>
          <Tooltip title="Edit Filter">
            <IconButton
              size="small"
              loading={actionsLoading}
              className="icon-btn-bordered"
              onClick={event => {
                event.stopPropagation();
                actions.onEdit!(filter.id);
              }}
            >
              <Edit color="primary" fontSize="small" />
            </IconButton>
          </Tooltip>
        </RenderWithCondition>

        <RenderWithCondition condition={typeof actions.onDelete === 'function'}>
          <Tooltip title="Remove Filter">
            <IconButton
              size="small"
              color="error"
              loading={actionsLoading}
              className="icon-btn-bordered"
              onClick={event => {
                event.stopPropagation();
                actions.onDelete!(filter.id);
              }}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </RenderWithCondition>
      </Stack>
    </Box>
  );
};
